export const plansHorsAfrique = {
  standard: {
    name: "Trimestriel",
    periode: "Trimestre",
    price: 295,
    priceId: "price_1RHovgGMWvy3X84igMbf6g5v",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
  professionnel: {
    name: "Trimestriel",
    periode: "Trimestre",
    price: 590,
    priceId: "price_1RHowAGMWvy3X84inSEvKXZ3",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
  enterprise: {
    name: "Annuel",
    periode: "an",
    price: 1180,
    priceId: "price_1RHowfGMWvy3X84i45PaGdFG",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
};

export const africPlans = {
  standard: {
    name: "Trimestriel",
    periode: "Trimestre",
    price: 150,
    priceId: "price_1RUX1dGMWvy3X84ikOzySlJx",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
  professionnel: {
    name: "Semestriel",
    periode: "Semestre",
    price: 300,
    priceId: "price_1RUX2GGMWvy3X84iKeGi1JOp",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
  enterprise: {
    name: "Annuel",
    periode: "an",
    price: 600,
    priceId: "price_1RUX3WGMWvy3X84ivD7DAtPW",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
};

export const companyPlans = {
  standard: {
    name: "Trimestriel",
    periode: "Trimestre",
    price: 200,
    priceId: "price_1RUXAeGMWvy3X84irmNz8usG",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
  professionnel: {
    name: "Semestriel",
    periode: "Semestriel",
    price: 400,
    priceId: "price_1RUXB6GMWvy3X84iUpdqbz3k",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },

  enterprise: {
    name: "Annuel",
    periode: "an",
    price: 800,
    priceId: "price_1RUXBJGMWvy3X84iXqGAquED",
    features: [
      "Tous les avantages Professionnel",
      "Accès aux webinaires exclusifs",
      "Réseau professionnel privilégié",
      "Participation aux événements",
      "Accès VIP aux conférences",
    ],
  },
};
